import { Outlet } from "react-router-dom";

const CorporateActionsService = () => {
  return <Outlet />;
};

export default CorporateActionsService;
